import React, { useEffect, useState } from 'react';
import { Home } from './pages/Home';
import { FiturPage } from './pages/FiturPage';
import { KontakPage } from './pages/KontakPage';
import { LanguageProvider } from './lib/LanguageContext';
type Page = 'home' | 'fitur' | 'kontak';
const PAGE_PATHS: Record<Page, string> = {
  home: '/',
  fitur: '/fitur',
  kontak: '/kontak'
};
function getPageFromPath(): Page {
  // Strip both /id and /en prefixes
  const path = window.location.pathname.replace(/^\/(en|id)/, '') || '/';
  if (path.startsWith('/fitur')) return 'fitur';
  if (path.startsWith('/kontak')) return 'kontak';
  return 'home';
}
export function App() {
  const [page, setPage] = useState<Page>(getPageFromPath);
  // On first load: if path is bare '/', redirect to '/id'
  useEffect(() => {
    if (window.location.pathname === '/') {
      window.history.replaceState({}, '', '/id');
    }
  }, []);
  // Sync React state when browser back/forward buttons are used
  useEffect(() => {
    const handlePopState = () => {
      setPage(getPageFromPath());
      window.scrollTo({
        top: 0,
        behavior: 'instant'
      });
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);
  const navigate = (newPage: Page) => {
    window.scrollTo({
      top: 0,
      behavior: 'instant'
    });
    setPage(newPage);
    // Determine current lang prefix
    const currentPath = window.location.pathname;
    const langPrefix = currentPath.startsWith('/en') ? '/en' : '/id';
    const path = newPage === 'home' ? langPrefix : `${langPrefix}${PAGE_PATHS[newPage]}`;
    window.history.pushState({}, '', path);
  };
  return <LanguageProvider data-id="element-0">
      {page === 'fitur' ? <FiturPage onBack={() => navigate('home')} data-id="element-1" /> : page === 'kontak' ? <KontakPage onBack={() => navigate('home')} data-id="element-2" /> : <Home onNavigate={navigate} data-id="element-3" />}
    </LanguageProvider>;
}